import React, { Component } from "react";
// import {Modal} from 'react-bootstrap';
import NewForm from './NewForm.js'
import ReAssign from './ReAssign.js'
export default class EditModalWindow  extends Component {  
  render(){
    const {link,edit} = this.props;
    return(
    //   <Modal
    //   show={true}
    //   onHide={this.props.closeModal}
    //   dialogClassName={(link) ? "modal-90w " :"modal-120w clientrecordxl"}
    //   size={(link) ? "lg" :"xl"}
    //  //aria-labelledby="contained-modal-title-vcenter"
    //   centered>
    //   <Modal.Header closeButton>
    //   <Modal.Title id="example-custom-modal-styling-title">
    //   {link ? 'Replace Web Form' : edit ? <span>{"Edit Web Form --"+form.title}</span> : <span>{"Create Web Form"}</span> }
    //   </Modal.Title>
    //   </Modal.Header>
    //   <Modal.Body>
        <div>
        {(link) ? 
          <ReAssign data={this.props.form} action={this.props.action} mapRequest={this.props.mapRequest}
          webFormNames={this.props.webFormNames} closeModal={this.props.closeModal} />
          :
        <NewForm edit={edit} form={this.props.form} action={this.props.action} webFormNames={this.props.webFormNames} loginAction={this.props.loginAction}
        closeModal={this.props.closeModal}/>
        }
        </div>
      //   </Modal.Body>
      // </Modal>

    )
  }
}